var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24 12.0735C24 5.40454 18.6269 -0.00146484 11.9999 -0.00146484C5.36995 3.51563e-05 -0.00305176 5.40454 -0.00305176 12.075C-0.00305176 18.1005 4.38595 23.0955 10.1219 24.0015V15.564H7.07695V12.075H10.1249V9.41253C10.1249 6.38704 11.9174 4.71603 14.6579 4.71603C15.9719 4.71603 17.3444 4.95154 17.3444 4.95154V7.92154H15.8309C14.3414 7.92154 13.8764 8.85303 13.8764 9.80853V12.0735H17.2034L16.6724 15.5625H13.8749V24C19.6109 23.094 24 18.099 24 12.0735Z","fill":"#3672AF"}));
}

FacebookInline.defaultProps = {"width":"32","height":"32","viewBox":"0 0 24 24","fill":"none"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
